import { Component } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { GenerateQrcodeComponent } from '../../../app/common/modal/generate-qrcode/generate-qrcode.component';
import { QrcodeManagementService } from '../../../app/common/services/qrcode-management.service';
import { QRCODE_MNGMNT_COLS } from './qrcode-management.component.col.def';

@Component({
  selector: 'app-qrcode-management',
  templateUrl: './qrcode-management.component.html',
  styleUrls: ['./qrcode-management.component.scss']
})
export class QrcodeManagementComponent {
  public colFields = QRCODE_MNGMNT_COLS;
  public tableData = {
    tableHeading: 'QR Memory Code Management', tableType: 'qrCode', serviceName: 'qrCodeService',
    containerClass: 'table-container-qr-code-detail', headClass: 'table-head-user', exportQrCode: true,
    rowClass: 'table-row-user', bodyClass: 'table-body-user', hideDownloadCsv: true, showGenerateQR: true
  };
  paramsAg: string;
  constructor(public modalService: BsModalService, public bsModalRef: BsModalRef, public _qrCodeService: QrcodeManagementService) { }



  generateQrCode() {
    this.modalService.show(GenerateQrcodeComponent, { class: 'max-width-607 modal-dialog-centered' });
  }

  /**
   *QR Code Call back
   @param event is action of an event
  */
  QRCallback(event: Array<number>) {
    if (event) {
      this.bsModalRef = this.modalService.show(GenerateQrcodeComponent,
        {
          animated: true, keyboard: true, backdrop: true, ignoreBackdropClick: false,
          class: 'max-width-607 modal-dialog-centered'
        });
      this.bsModalRef.content.onClose.subscribe((result) => {
        if (result.close) {
          if(result.generateQrCodeForm.agentID){
            this.paramsAg = 'number=' + result.generateQrCodeForm.qrCodeNumber + '&vendor_id=' + result.generateQrCodeForm.agentID;
           } else{
             this.paramsAg = 'number=' + result.generateQrCodeForm.qrCodeNumber;
           }
          this._qrCodeService.generateQRCode(this.paramsAg).subscribe();
        }
      });
    };
  }
}
